export default {
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',
  'component.tagSelect.day': '天',
  'component.tagSelect.mouth': '月',
  'component.tagSelect.year': '年',
  'component.tagSelect.disable': '禁用',
  'component.tagSelect.enable': '启用',
  'component.tagSelect.normal': '正常',
  'component.tagSelect.man': '男',
  'component.tagSelect.woman': '女',
  'component.tagSelect.yes': '是',
  'component.tagSelect.no': '否',

  'component.button.more': '更多',
  'component.button.search': '查询',
  'component.button.reset': '重置',
  'component.button.add': '新增',
  'component.button.addDevice': '新增设备',
  'component.button.ConfirmPasswordReset': '是否重置密码?',
  'component.button.PasswordResetmsg': '密码重置成功!',
  'component.button.PasswordResettigs': '请记住密码，密码只展示一次!',
  'component.button.copydone': '已经复制到剪切板了',
  'component.button.copypas': '点击复制密码',
  'component.button.ResetPassword': '重置密码',
  'component.button.roleAssignment': '角色分配',
  'component.button.AssignedRole': '已分配角色',
  'component.button.undistributed': '未分配角色',
  'component.button.edit': '编辑',
  'component.button.sure': '确定',
  'component.button.Cancel': '取消',
  'component.button.goback': '返回',
  'component.button.AssignPermissions': '权限分配',
  'component.button.save': '保存',
  'component.button.detail': '详情',
  'component.button.delete': '删除',
  'component.button.uploadPic': '上传图片',
  'component.button.uploadfile': '选择文件',
  'component.button.uploadfile1': '选择文件(支持多个)',
  'component.button.files': '附属文件(支持多个)',
  'component.button.delay': '延期',
  'component.button.binding': '绑定',
  'component.button.account': '账号',
  'component.button.password': '密码',
  'component.button.upload': '上传',
  'component.button.download': '下载',
  'component.button.Reupload': '重新上传',

  'component.Placeholder.select': '请选择',
  'component.Placeholder.input': '请输入',
  'component.Placeholder.min': '最小',
  'component.Placeholder.max': '最大',
  'component.validation.selectRequired': '请选择{label}',
  'component.validation.inputRequired': '请输入{label}',
  'component.Placeholder.inputuser': '请填写用户名！',
  'component.Placeholder.rulesPhone': '请输入正确的手机号!',
  'component.Placeholder.rulesemail': '请输入正确的邮箱!',
  'component.Placeholder.gneder': '请选择性别',
  'component.Placeholder.inputrole': '请填写角色名',

  'component.title.EnableUser': '确认启用该用户?',
  'component.title.disabledUser': '确认禁用该用户?',
  'component.title.suredeleterole': '确认删除角色?',
  'component.title.suredeleteship': '是否要删除船舶?',
  'component.title.suredeletepad': '是否要删除pad?',
  'component.title.editUser': '修改用户',
  'component.title.Selected': '已选',
  'component.title.items': '项',
  'component.title.addRole': '角色添加',
  'component.title.createRole': '创建角色',
  'component.title.enable': '是否要启用?',
  'component.title.disabled': '是否要禁用?',
  'component.title.binddevicesuccess': '设备绑定成功!',
  'component.title.binddevice': '设备绑定',

  'component.title.EnergyList': '能源列表',
  'component.title.Energytigs': '选择本船常用的燃料种类，最多选择5个',
  'component.title.Energytigs1': '燃料种类最多5个',

  'component.title.CorrectedCIIrating': '纠正后CII评级',
  'component.title.CorrectedCIIrating1': '选择所属船舶',
  'component.title.CorrectedCIIrating2': '上一个年度评级',
  'component.title.CorrectedCIIrating3': '所选船舶上一个历年的CII评级详情',
  'component.title.CorrectedCIIrating4': '设置评级目标',
  'component.title.ciiRating': 'CII评级目标',

  'shipWeb.workplace.SummaryAnalysis': '概要分析',
  'shipWeb.workplace.customers': '客户总数',
  'shipWeb.workplace.treasures': '凡碳宝数',
  'shipWeb.workplace.sailingRecord': '年度航行记录(条)',
  'shipWeb.workplace.emissions': '年度碳排总数(吨)',
  'shipWeb.workplace.travelled': '年度航行里程(海里)',
  'shipWeb.workplace.addCustomer': '新增客户',
  'shipWeb.workplace.updateCustomer': '更新客户',
  'shipWeb.workplace.ImminentCustomer': '临期客户',
  'shipWeb.workplace.LatestVoyageRecords': '最新航行记录',
  'shipWeb.workplace.EnergyConsumptionAndCarbonEmissions': '能耗和碳排',

  'system.usermanage.usermanage': '用户管理',
  'system.rolesmanage.rolesmanage': '角色管理',
  'system.customer.customer': '客户列表',
  'system.ship.shiplist': '船舶列表',
  'system.addship.Basicdata': '基础数据',
  'system.addship.TypesofEnergy': '能源种类',
  'system.addship.nextStep': '下一步',
  'system.addship.PreviousStep': '上一步',
  'system.pad.padlist': '凡碳宝列表',
  'system.pad.addpad': '新增凡碳宝',
  'system.pad.editpad': '编辑凡碳宝',

  'component.footer.copyright': 'Powered by Ant Design',
  'component.footer.antDesignPro': 'Ant Design Pro',
  'component.footer.antDesign': 'Ant Design',
  'component.avatarDropdown.personalCenter': '个人中心',
  'component.avatarDropdown.personalSettings': '个人设置',
  'component.avatarDropdown.logout': '退出登录',
};
